'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, s = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(o = 0; o < n.length; o++)t = n[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (s[t] = e[t]);
    }
    return s;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, s = {}, n = Object.keys(e);
    for(o = 0; o < n.length; o++)t = n[o], r.indexOf(t) >= 0 || (s[t] = e[t]);
    return s;
}
const BaseTileOverlay = renderWithRef('BaseTileOverlay', null, (t, o)=>{
    let { children: s, inset: n = 'standard', position: a, showOnHoverOrFocus: l = false } = t, i = _object_without_properties(t, [
        "children",
        "inset",
        "position",
        "showOnHoverOrFocus"
    ]), c = new Set([
        'swan-base-tile-overlay',
        `swan-base-tile-overlay-${a}`
    ]);
    return 'standard' !== n && c.add(`swan-base-tile-overlay-${n}`), l && c.add("swan-base-tile-overlay-show-on-hover-or-focus"), jsx(RenderComp, {
        root: "div",
        forwardedRef: o,
        classNames: c,
        props: i,
        children: s
    });
});

export { BaseTileOverlay };
